import axiosClient from "../axios-config";

export default {
  postDemonstration(formData) {
    return axiosClient.post('/ticket/demonstration', formData);
  }
}